/**
 * @description Handle ViewMore button behaviour and show hidden refinement after click on it.
 * @param {typeof import('widgets/Widget').default} Widget Base widget for extending
 */

export default function (Widget) {
    return class PDAccordionMgr extends Widget {
        prefs() {
            return {

                ...super.prefs() //extend preferences from parent widget class
            };
        }
        init = async () => {
            this.accordionOpenOnLoad();
            document.querySelectorAll('.experience-commerce_assets-accordionItem .title').forEach(item => {
                item.addEventListener('click', () => this.accordionClick(item));
            });

        }
        accordionClick = (accordion) => {
            const parent = accordion.parentElement;
            if (parent.classList.contains('active')) {
                parent.classList.remove('active');
                return;
            } else {
                document.querySelectorAll('.experience-commerce_assets-accordionItem').forEach(child => {
                    child.classList.remove('active');
                });
            }
            parent.classList.add('active');
        }
        accordionOpenOnLoad = () => {
            if(window.location.hash) {
                const hash = window.location.hash;
                const accordionItem = document.querySelector(hash);
                if (accordionItem) {
                    accordionItem.classList.add('active');
                    const title = accordionItem.querySelector('.title');
                    if (title) {
                        title.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }
        } 
    }
}